export const getEnablePaymentConstraintsEmbeddedCheckout = (state) =>
    state.app.featureFlags.enablePaymentConstraintsEmbeddedCheckout || false;

export const getEnableStoredPaymentMethods = (state) =>
    state.app.featureFlags.enableStoredPaymentMethods || false;
